import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=518b3484&"
import script from "./UploadData.vue?vue&type=script&lang=ts&"
export * from "./UploadData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518b3484')) {
      api.createRecord('518b3484', component.options)
    } else {
      api.reload('518b3484', component.options)
    }
    module.hot.accept("./UploadData.vue?vue&type=template&id=518b3484&", function () {
      api.rerender('518b3484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/upload-data/UploadData.vue"
export default component.exports